/**
 * Constants for TemplateAndSubmissionAccess component
 */

export const COMPONENT_CONSTANTS = {
  HEADERS: {
    TEMPLATE_ACCESS: 'Template Access',
    SUBMISSION_ACCESS: 'Submission Access',
    PERMISSION: 'Permission',
  },
  LAYOUT: {
    ASSIGNEE_FLEX: '60%',
    PERMISSION_FLEX: '40%',
  },
} as const;
